module.exports = __webpack_public_path__ + "static/media/Gotham-Medium.7a8870fb.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./src/fonts/Gotham-Medium.eot
 ** module id = 1341
 ** module chunks = 0
 **/